import { render, staticRenderFns } from "./img_video.vue?vue&type=template&id=4f239b02&scoped=true&"
import script from "./img_video.vue?vue&type=script&lang=js&"
export * from "./img_video.vue?vue&type=script&lang=js&"
import style0 from "./img_video.vue?vue&type=style&index=0&id=4f239b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f239b02",
  null
  
)

export default component.exports